import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { ApiIntegration } from '../../_services/api.integration';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-create-ticket',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.scss'],
})
export class CreateTicketComponent implements OnInit {
  subject: string;
  category: string;
  subjectError: string;
  description: string;
  descriptionError: string;
  categoryError: string;
  attachment: any;
  imageUrl: string;
  errorMessage: string;
  ticket: any;
  attachmentError: string;

  constructor(private alertService: AlertService, private user: User, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration) {
    this.category = "General";
  }

  addAttachment(event) {
    this.attachment = event.target.files[0];
  }

  blurDescription() {
    this.descriptionError = "";
    if (!this.description) {
      this.descriptionError = 'Please enter description';
    }
  }

  blurSubject() {
    this.subjectError = "";
    if (!this.subject) {
      this.subjectError = 'Please enter subject';
    }
  }

  blurCategory() {
    this.categoryError = "";
    if (!this.category) {
      this.categoryError = 'Please select category';
    }
  }

  attachmentBlur() {
    this.attachmentError = "";
    if (!this.attachment) {
      this.attachmentError = 'Please select attachment';
    }
  }

  ngOnInit() {
  }

  submit() {
    this.descriptionError = "";
    this.subjectError = "";
    this.categoryError = "";

    if (!this.description) {
      this.descriptionError = 'Please enter description';
    }
    if (!this.subject) {
      this.subjectError = 'Please enter subject';
    }
    if (!this.category) {
      this.categoryError = 'Please select category';
    }

    if (this.descriptionError !== "" || this.subjectError !== "" || this.categoryError !== "") {
      return false
    }
    let body = {
      "accountOwnerId": this.user.accountOwnerId,
      "category": this.category,
      "description": this.description,
      "organizationId": this.user.organizationId,
      "subject": this.subject,
      "userId": this.user.userId,
      "attachments": [],
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createSupportTicket', body,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.ticket = data['sourceTicketId'];
          this.alertService.success('Success', data['message']);
          this.newApi();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }

  newApi() {
    this.g.loaderDisplay = "display";
    const file = this.attachment;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/addAttachment?organizationId=' + this.user.organizationId + "&ticketId=" + this.ticket, formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      this.router.navigate(['/admin/ticketList']);
      if (data['code'] == 200) {
      } else {
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.router.navigate(['/admin/ticketList']);
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

}
